import { useEffect } from 'react';
import { loadWalletInfoAsync } from '../../data-layer/cpa/actions';
import { selectWalletInfo } from '../../data-layer/cpa/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import { canShowCpa } from '../../utils/accessService';
import { useBusinessModel } from '../business/useBusinessModel';
import { WALLET_RELEVANT_STATUSES } from './CpaContainer/constants';
import { useCurrentUser } from './useCurrentUser';

export const useCpaPromoBalance = () => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const businessId = currentUser?.profile?.publicId || '';
    const business = useBusinessModel({ businessId });
    const cpaEnabled = canShowCpa(currentUser, business);
    const walletInfo = useSelector(selectWalletInfo);

    const shouldLoadWalletInfo =
        cpaEnabled &&
        currentUser?.cpaStatus &&
        WALLET_RELEVANT_STATUSES.includes(currentUser.cpaStatus) &&
        !walletInfo;

    useEffect(() => {
        if (shouldLoadWalletInfo) {
            dispatch(loadWalletInfoAsync());
        }
    }, [dispatch, shouldLoadWalletInfo]);

    return walletInfo?.balance;
};
